import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './components/App';
import { featureFlags } from './config/featureFlags';

// Enable auth bypass when running the Vite dev server locally
if (import.meta.env.DEV) {
  featureFlags.bypassAuth = true;
}

/**
 * Application Entry Point
 *
 * Renders the main App component with React StrictMode for development checks
 *
 * Requirements:
 * - 7.1: Use Vite as the build tool for fast development and optimized production builds
 * - 7.2: Use AWS UI Components (Cloudscape) for consistent UX
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
